import React, { TextareaHTMLAttributes } from 'react';

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
};
const LocalTextArea = ({ label, className, ...props }: TextAreaProps) => {
  return (
    <div>
      <label className='text-[#2E3031] font-medium'>
        {label}
        <textarea
          {...props}
          className={`w-full border-[#D5D6D7]  bg-[#FAFAFA] font-medium z-1 relative focus:outline-none border-b-2 ${
            props.disabled ? 'bg-[#F4F5F5]' : 'bg-[#FAFAFA]'
          } py-4 min-h-[100px]  pl-[14px] mt-1 ${className} `}
          placeholder={props.placeholder}
        />
      </label>
    </div>
  );
};

export default LocalTextArea;
